import LocationsTableReducer from "./reducers/LocationsTableReducer";
import LocationsSaga from "./saga";

import IConfig from "interfaces/IConfig";
import store from "rootStore";
import { permissionsType, routingType } from "types/configTypes";
import AsyncComponent from "ui/AsyncComponent";

export const moduleName = "backofficepayment.locations";
export const url = "locations";
export const groupsUrl = `${url}/groups`;

const getConfig = (permissions: permissionsType, parentUrl: string) => {
    const config: IConfig = {
        active: false,
        routing: [],
        url,
    };

    let routing: routingType = [];

    if (permissions["backofficepayment.locations.read"]) {
        config.active = true;

        store.reducerManager?.add(
            "BackofficePaymentLocationTable",
            LocationsTableReducer
        );
        store.injectSaga?.("BackofficePaymentLocationsSaga", LocationsSaga);
        routing.push({
            path: url,
            element: (
                <AsyncComponent path="BackofficePayment/Locations/pages/LocationsIndexPage" />
            ),
        });
    }

    if (permissions["backofficepayment.locations.create"]) {
        routing.push({
            path: `${url}/create`,
            element: (
                <AsyncComponent path="BackofficePayment/Locations/pages/LocationsCreatePage" />
            ),
        });
    }
    if (permissions["backofficepayment.locations.update"]) {
        routing.push({
            path: `${url}/:id/edit`,
            element: (
                <AsyncComponent path="BackofficePayment/Locations/pages/LocationsEditPage" />
            ),
        });
    }

    if (routing.length > 0) {
        config.routing = routing.map((item) => parentUrl + "/" + item.path);
    }

    return { config, routing };
};

export default getConfig;
